import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { FirmSelectionService, selectedFirmName } from '../firm-selection.service';
import { filter, switchMap, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReadyProductService {
  private currentFirm: selectedFirmName | null = null;
  private apiUrl = environment.apiBaseUrl;
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private firmSelectionService: FirmSelectionService
  ) {
    // subscribe once to keep currentFirm in sync
    this.firmSelectionService.selectedFirmName$.subscribe(firm => {
      this.currentFirm = firm;
    });
  }

  private appendFirmParam(params?: HttpParams): HttpParams {
    let newParams = params || new HttpParams();
    if (this.currentFirm && this.currentFirm.id) {
      newParams = newParams.set('firm_id', this.currentFirm.id.toString());
    }
    return newParams;
  }

  getReadyProducts(queryParams: HttpParams = new HttpParams()): Observable<any> {
    return this.firmSelectionService.selectedFirmName$.pipe(
      filter((firm): firm is selectedFirmName => !!firm), // wait until firm is set
      take(1), // take only the first non-null firm
      switchMap(firm => {
        const params = queryParams.set('firm_id', firm.id.toString());
        return this.apiService.get('ready_product', params);
      })
    );
  }

  createReadyProduct(data: any) {
    return this.apiService.post('ready_product', data);
  }

  getReadyProduct(id: any) {
    const params = this.appendFirmParam();
    return this.apiService.get(`ready_product/${id}`, params);
  }

  updateReadyProduct(id: string | number, formData: FormData): Observable<any> {

  const token = sessionStorage.getItem('token');

  const headers = {
    'X-HTTP-Method-Override': 'PUT',
    Authorization: `Bearer ${token}`,
  };

  return this.http.post(`${this.apiUrl}ready_product/${id}`, formData, { headers });

}

  deleteReadyProduct(id: any) {
    return this.apiService.delete(`ready_product/${id}`);
  }

  getReadyProductByCode(code: any) {
    let params = new HttpParams().set('product_code', code);
    params = this.appendFirmParam(params);
    return this.apiService.get('ready_product', params);
  }

  getPackagingStacks() {
    const params = this.appendFirmParam(
      new HttpParams().set('type_for_packaging_stack', 'Packaging Stack')
    );
    return this.apiService.get('products', params);
  }

  getNextCodeByPrefix(prefix: string) {
    let params = new HttpParams().set('prefix', prefix);
    params = this.appendFirmParam(params);
    return this.apiService.get('ready-product/get-next-code', params);
  }
}
